import React from 'react';
import { MobXProviderContext } from 'mobx-react';
import RootStore from '../stores/root-store';

export function useStores(): RootStore {
  // `MobXProviderContext` is typed as `any`, so we need a type assertion here:
  return React.useContext(MobXProviderContext) as RootStore;
}
